import { Navigate, Outlet, useLocation } from 'react-router';

import { Spinner } from '@shared';

import { useAuth } from '@/features/auth/useAuth';
import { useTranslations } from '@/i18n/client';

/**
 * Guards the authenticated area.
 *
 * - While the stored session is being re-verified (`initializing`), shows a spinner.
 * - When unauthenticated, redirects to /login.
 * - When authenticated but without an organization, redirects to /register/organization
 *   (unless already there, to avoid a redirect loop).
 */
export function ProtectedRoute() {
  const { status, hasOrganization } = useAuth();
  const location = useLocation();
  const t = useTranslations('common.status');
  const isOrganizationRoute = location.pathname.replace(/\/+$/, '') === '/register/organization';

  if (status === 'initializing') {
    return (
      <div className="zs-center">
        <Spinner label={t('restoringSession')} />
      </div>
    );
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (hasOrganization && isOrganizationRoute) {
    return <Navigate to="/" replace />;
  }

  if (!hasOrganization && !isOrganizationRoute) {
    return <Navigate to="/register/organization" replace />;
  }

  return <Outlet />;
}
